import { Student } from "../../shared-components/student/student.model";


export class CommunicationLogFilterParam {

    studentNumber?: string;
    students?: Student[] = [];
    type?: string;
    subject?: string;
    result?: string;
    fromLogDate?: string;
    toLogDate?: string;
  
    constructor() {
    }
  }